import { animate as animate3 } from "./js-vendor.min.js";

let fetchCart = new Promise(async (resolve) => {
	resolve(await (await fetch(`${Shopify.routes.root}cart.js`)).json());
});
document.addEventListener('cart:change', (event) => {
	fetchCart = event.detail['cart'];
});

const CartCount = class extends HTMLElement {
	constructor() {
		super();
		this.attachShadow({ mode: 'open' }).appendChild(
			document
				.createRange()
				.createContextualFragment('<span><slot></slot></span>'),
		);
		this._updateTimer = null;
		this._updateFromServer();
	}
	connectedCallback() {
		this._abortController = new AbortController();
		// Listen for cart change events
		document.addEventListener(
			'cart:change',
			(event) => (this.itemCount = event.detail['cart']['item_count']),
			{
				signal: this._abortController.signal,
			},
		);
		document.addEventListener('cart:refresh', () => this._updateFromServer(), {
			signal: this._abortController.signal,
		});
		// The cart drawer can dispatch `cart:updated` multiple times during async app flows (e.g. Bogos).
		// Debounce server fetch so the bubble doesn't jump to the final value before the drawer UI catches up.
		document.addEventListener(
			'cart:updated',
			() => {
				if (this._updateTimer) window.clearTimeout(this._updateTimer);
				this._updateTimer = window.setTimeout(() => {
					this._updateTimer = null;
					this._updateFromServer();
				}, 2600);
			},
			{ signal: this._abortController.signal },
		);
	}
	disconnectedCallback() {
		this._abortController.abort();
	}
	async _updateFromServer() {
		this.itemCount = this.itemCount = (await fetchCart)['item_count'];
	}
	get itemCount() {
		return parseInt(this.innerText);
	}
	set itemCount(count) {
		if (this.itemCount === count) {
			return;
		}
		if (count === 0) {
			animate3(this, { opacity: 0 }, { duration: 0.1 });
			this.innerText = count;
		} else if (this.itemCount === 0) {
			animate3(this, { opacity: 1 }, { duration: 0.1 });
			this.innerText = count;
		} else {
			(async () => {
				await animate3(
					this.shadowRoot.firstElementChild,
					{ transform: ['translateY(-50%)'], opacity: 0 },
					{ duration: 0.25, easing: [1, 0, 0, 1] },
				).finished;
				this.innerText = count;
				animate3(
					this.shadowRoot.firstElementChild,
					{ transform: ['translateY(50%)', 'translateY(0)'], opacity: 1 },
					{ duration: 0.25, easing: [1, 0, 0, 1] },
				);
			})();
		}
	}
};
if (!window.customElements.get('cart-count')) {
	window.customElements.define('cart-count', CartCount);
}
